"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _moment = _interopRequireDefault(require("moment"));
var _s = require("@/plugins/s3");
var _uuid = require("uuid");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "UploadSingleImage",
  props: {
    pathImage: String,
    disabled: {
      type: Boolean,
      default: false
    },
    urlUpload: String
  },
  data: function data() {
    return {
      isProgressing: false,
      percentUpload: 0
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["$baseUrl", "token"])), {}, {
    computeWidth: function computeWidth() {
      if (isNaN(this.width)) {
        return this.width;
      }
      return "".concat(this.width, "px");
    },
    computeHeight: function computeHeight() {
      if (isNaN(this.height)) {
        return this.height;
      }
      return "".concat(this.height, "px");
    }
  }),
  methods: {
    handlePreviewImage: function handlePreviewImage() {
      this.$refs.imagePreview.$el.children[0].click();
    },
    onProgress: function onProgress(percent) {
      this.percentUpload = +percent.toFixed(0);
    },
    onError: function onError(err, file, fileList) {
      if (err.message) {
        this.$message.error(err.message);
      }
      this.isProgressing = false;
    },
    emitSuccess: function emitSuccess(url) {
      this.$emit("upload:success", url);
    },
    handleSuccess: function handleSuccess(res, file) {
      this.emitSuccess(res.data.path);
    },
    beforeUpload: function beforeUpload(file) {
      var acceptTypes = ["png", "jpg", "jpeg"];
      var isJPG = acceptTypes.some(function (type) {
        return file.type.includes(type.toLowerCase());
      });
      if (!isJPG) {
        this.$message.error("Chỉ hỗ trợ định dạng PNG, JPG!");
        return false;
      }
      if (this.sizeLimit) {
        if (file.size > 1024 * 1024 * this.sizeLimit) {
          this.$message.error("\u1EA2nh k\xEDch th\u01B0\u1EDBc t\u1ED1i \u0111a l\xE0 ".concat(this.sizeLimit, "MB!"));
          return false;
        }
      }
      return true;
    }
  }
};